// extracted by mini-css-extract-plugin
export default {"root":"Header_root__pUE-6","logo":"Header_logo__lGT-4"};